// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2isH6","right":"styles_right__3XpE7"};